module.exports = __webpack_public_path__ + "img/4.0e6149b6.jpg";